export const soundUrl = "https://supermixstudio-sounds.s3.us-west-2.amazonaws.com/sounds/";

export const sounds = Object.freeze({
  CHANGE_COLOR: "changeColor.mp3",
  SELECTING_CATEGORY: "selectingCategory.mp3",
  SELECTING_SUBCATEGORY: "selectingSubcategory.mp3",
  SELECT_FAVORITE_PATCH: "selectFavoritePatch.mp3",
  START_DESIGN: "startDesign.mp3",
  MORE_PATCHES: "morePatches.mp3",
  VIEW: "view.mp3",
  ERROR_FIT_SOUND: "errorFitSound.mp3",
  NORMAL_FIT_PATCH: "normalFitPatch.mp3",
  SUPER_SIZE_FIT_PATCH: "superSizeFitPatch.mp3",
  ADD_TO_BAG: "addToBag.mp3",
});
